<template>
    <hts-router-drawer
        ref="routerDrawer"
        :title="$t('labels.editBankAccount')"
        :size="50"
        :submit="submit"
        no-reset
        :rules="rulesCooperatorContact"
        @loaded="getData"
        @refresh-tables="refreshTables">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-select-currency-unit
                v-model="formData.currency"
                required
                prop="accountUseCurrency"
                name="accountUseCurrency" />
            <hts-form-select
                v-model="formData.bank"
                :items="listBankAccounts()"
                :label="$t('labels.bank')"
                required
                key-id="key"
                key-label="name"
                :clearable="true"
                prop="bank"
                name="bank" />
            <hts-form-input
                v-model="formData.bankAccountNumber"
                :label="$t('labels.bankAccountNumber')"
                required
                prop="bankAccountNumber"
                name="bankAccountNumber" />
            <hts-form-input
                v-model="formData.bankBranch"
                :label="$t('labels.bankBranch')"
                required
                prop="bankBranch"
                name="bankBranch" />
            <hts-form-input
                v-model="formData.beneficiary"
                :label="$t('labels.beneficiary')"
                required
                prop="beneficiary"
                name="beneficiary" />
        </hts-card>
    </hts-router-drawer>
</template>

<script setup lang="ts">
import bank from '../ignore/bank'
const { listBankAccounts } = bank()

const rulesCooperatorContact = {
  accountUseCurrency: 'required',
  bank: 'required',
  bankAccountNumber: 'required',
  bankBranch: 'required',
  beneficiary: 'required'
}

const cooperatorId = computed(() => useRoute().params.idpartner)
const bankId = computed(() => useRoute().params.idbank)
const visible = ref(false)
const loading = ref(false)
const routerDrawer = ref()
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  }
})

const formData = reactive({
  currency: '',
  bank: '',
  bankAccountNumber: '',
  bankBranch: '',
  beneficiary: ''
})
const emits = defineEmits(['refreshTables'])

const refreshTables = () => {
  emits('refreshTables')
}

const submit = async () => {
  const api = $urlPartner.partner.bank.update
  const data: any = await $api(api, { uriParams: { cooperatorId: cooperatorId.value, bankId: bankId.value }, body: formData })
  const resData = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('labels.updateBankAccountSuccess'))
    if (routerDrawer?.value) {
      routerDrawer.value.handleSubmitClose()
    }
  }
}

const getData = () => {
  const api = $urlPartner.partner.bank.detail
  $api(api, { uriParams: { cooperatorId: cooperatorId.value, bankId: bankId.value } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      loading.value = true
      if (!resData.data.cooperatorPolicy) {
        delete resData.data.cooperatorPolicy
      }
      Object.assign(formData, { ...resData.data })
    }
  })
}
</script>
